<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems=" nav " />
      <main class="main">
        <breadcrumb :list=" list " />
        <div class="container-fluid">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </main>
      <AppAside />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import nav from '../_nav'
// import { getter } from 'vuex'
import {Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb} from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.itemsIonBeta
    }
  },
  created () {
    this.menu()
  },
  methods: {
    async menu () {
      var akses = await this.$store.getters['auth/user']
      console.log(akses.ppjk)
      if (akses.ppjk === 'M') {
        this.nav = nav.itemsBarpin
      } else if (akses.ppjk === 'Y') {
        this.nav.push(nav.barpin)
      }
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue?be6ff80e